import { registerIsland, type IslandRegistration } from "~/types/islands";

/**
 * Island Registry
 *
 * This is the central registry for all islands in the application.
 * Islands are dynamically loaded and mounted based on data-island attributes.
 *
 * To add a new island:
 * 1. Create your island component (e.g., islands/my-island/MyIsland.svelte)
 * 2. Ensure your component's props extend IslandProps:
 *    ```typescript
 *    interface Props extends IslandProps {
 *      myCustomProp: string;
 *    }
 *    let { name, queryClient, myCustomProp }: Props = $props();
 *    ```
 * 3. Register the island using the registerIsland() helper:
 *    ```typescript
 *    registerIsland({
 *      name: "my-island",
 *      importer: () => import("~/islands/my-island/MyIsland.svelte")
 *    })
 *    ```
 * 4. Use in Liquid templates by adding an element with a
 *    data-island="my-island" attribute, optionally with a
 *    data-props="{ 'arbitraryJson': 'value'}" attribute to pass props
 *    at mount time.
 */
export const ISLAND_REGISTRY: IslandRegistration[] = [
  registerIsland({
    name: "test-banner",
    importer: () => import("~/islands/dynamic/TestBanner.svelte"),
  }),
  registerIsland({
    name: "badge",
    importer: () => import("~/islands/dynamic/badge/BadgeIsland.svelte"),
  }),
  registerIsland({
    name: "recommendations",
    importer: () => import("~/islands/dynamic/recommendations/RecommendationsIsland.svelte"),
  }),
  // Add more dynamic islands here using registerIsland() as later increments
  // migrate them.
];
